/** Shared layout breakpoints/dimensions for the app shell. */

/**
 * Viewport width (px) at/above which the inline desktop sidebar is shown. Below
 * this width there is no sidebar at all: the phone shell (top row + bottom bar)
 * takes over and nothing occupies layout width, so fixed-position elements
 * (chat composer, welcome overlay) must drop their sidebar offset.
 *
 * This is the one "phone vs desktop" line (`useViewport`). MUST stay in sync
 * with the `--breakpoint-nav` token in index.css (the `nav:` Tailwind variant).
 */
export const NAV_BREAKPOINT_PX = 900;

/**
 * Viewport width (px) at/above which a surface may lay out three panels (mail
 * list + reader + rail, contacts list + detail). Between the nav breakpoint and
 * this one there is a sidebar but only room for a single content column.
 */
export const WIDE_BREAKPOINT_PX = 1024;

/**
 * Default width of the Chat tab's own conversation sidebar (`ChatSidebar`),
 * shown at the nav breakpoint and above. The user can resize and collapse it;
 * the chat composer follows by measuring its column, not by this constant.
 */
export const CHAT_SIDEBAR_WIDTH_PX = 224;
